import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PendingScreenLayer from "../components/PendingScreenLayer";

const PendingScreenPage = ({ title }) => {
  return (
    <MasterLayout>
      <Breadcrumb title={title} />
      <PendingScreenLayer title={title} />
    </MasterLayout>
  );
};

export default PendingScreenPage;
